import { createSlice } from "@reduxjs/toolkit";
import {
  fetchStudentHistory,
  fetchTestdata,
  fetchTestTableData,
  fetchTraineedata,
  fetchTraineeTestAnswerSheet,
  fetchTraineeTestQuestions,
  parse_time,
  proceedToTest,
} from "../features/trianeeAsync";

const initialState = {
  isProceeding: false,
  invalidUrl: false,
  testid: null,
  traineeid: null,
  initialloading1: true,
  initialloading2: true,
  testbegins: false,
  startedWriting: false,
  testconducted: false,
  LocaltestDone: false,
  allStudentTest: [],
  loading: false,
  error: null,
  allTutorLoading: false,
  allTutor: [],
  studentHistory: [],
  studentHistoreyLoading: false,
  m_left: 0,
  s_left: 0,
  traineeDetails: {},
  activeQuestionIndex: 0,
  questions: [],
  answers: [],
  hasGivenFeedBack: false,
  TestsearchText: "",
  title: "",
  uploadedFileData:{},
  TestDetailsmodalOpened: false,
  DataActiveTestDetails: {
    testDetailsId: null,
  },
  customAnswer: [],
};

const testSlice = createSlice({
  name: "trainee",
  initialState,
  reducers: {
    setHasGivenFeedback(state, action) {
      state.hasGivenFeedBack = action.payload;
    },
    setTraineeTestDetails(state, action) {
      // Expecting payload: { testid, traineeid }
      state.testid = action.payload.testid;
      state.traineeid = action.payload.traineeid;
    },
    fetchPending: (state, action) => {
      const { data } = action.payload;

      if (data.pending) {
        const t = parse_time(data.pending);
        state.testbegins = data.testbegins;
        state.startedWriting = data.startedWriting;
        state.testconducted = data.testconducted;
        state.LocaltestDone = data.completed;
        state.m_left = t.m_left;
        state.s_left = t.s_left;
      }
    },
    invalidTestUrl(state) {
      state.invalidUrl = true;
    },
    testDoneLocal(state) {
      state.LocaltestDone = true;
    },
    proceedingToTest(state, action) {
      state.isProceeding = action.payload;
    },
    switchQuestion(state, action) {
      state.activeQuestionIndex = action.payload;
    },
    fetchLoggedInTrainee(state, action) {
      state.initialloading2 = false;
      state.traineeDetails = action.payload;
    },
    changeStudentTestTableLoadingStatus(state, action) {
      // Expecting payload: { loading, tests }
      state.loading = action.payload.loading;
      state.allStudentTest = action.payload.tests;
    },
    changeStudentSearchTutorLoadingStatus(state, action) {
      // Expecting payload: { loading, tutors }
      state.allTutorLoading = action.payload.loading;
      state.allTutor = action.payload.tutors;
    },
    changeStudentHistoryTestTableLoadingStatus(state, action) {
      // Expecting payload: { loading, history }
      state.studentHistoreyLoading = action.payload.loading;
      state.studentHistorey = action.payload.history;
    },
    changeTestSearchText(state, action) {
      state.TestsearchText = action.payload;
    },
    updateTraineeTestQuestions(state, action) {
      const { payload, payload1 } = action.payload;
      state.questions = payload;
      state.title = payload1;
    },
    updateTraineeTestQuestionsResult(state, action) {
      state.questions = action.payload;
    },
    changeTestDetailsModalState(state, action) {
      // Expecting payload: { opened, testDetailsId }
      state.TestDetailsmodalOpened = action.payload.opened;
      state.DataActiveTestDetails.testDetailsId = action.payload.testDetailsId;
    },
    updateTraineeTestAnswerSheet(state, action) {
      state.answers = action.payload;
      state.customAnswer = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestTableData.pending, (state) => {
        state.loading = true;
        state.allStudentTest = [];
        state.error = null;
      })
      .addCase(fetchTestTableData.fulfilled, (state, action) => {
        state.loading = false;
        state.allStudentTest = action.payload;
      })
      .addCase(fetchTestTableData.rejected, (state, action) => {
        state.loading = false;
        state.allStudentTest = [];
        state.error = action.payload;
      })
      .addCase(fetchTestdata.fulfilled, (state, action) => {
        state.testbegins = action.payload.testbegins;
        state.startedWriting = action.payload.startedWriting;
        state.testconducted = action.payload.testconducted;
        state.LocaltestDone = action.payload.completed;
        state.m_left = action.payload.m_left;
        state.s_left = action.payload.s_left;
        state.initialloading2 = false;
        state.initialloading1 = false;
        state.error = null;
      })
      .addCase(fetchTestdata.rejected, (state, action) => {
        state.error = action.payload || "Failed to fetch test data";
      })
      .addCase(proceedToTest.pending, (state) => {
        state.isProceeding = true;
        state.error = null;
      })
      .addCase(proceedToTest.fulfilled, (state) => {
        state.isProceeding = false;
      })
      .addCase(proceedToTest.rejected, (state, action) => {
        state.isProceeding = false;
        state.error = action.payload || "Proceed to test failed";
      })
      .addCase(fetchTraineedata.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTraineedata.fulfilled, (state, action) => {
        state.traineeDetails = action.payload;
        state.loading = false;
      })
      .addCase(fetchTraineedata.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(fetchTraineeTestQuestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTraineeTestQuestions.fulfilled, (state, action) => {
        const { questions, title } = action.payload;
        state.loading = false;
        state.questions = questions;
        state.title = title;
      })
      .addCase(fetchTraineeTestQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTraineeTestAnswerSheet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTraineeTestAnswerSheet.fulfilled, (state, action) => {
        state.loading = false;
        state.answers = action.payload;
      })
      .addCase(fetchTraineeTestAnswerSheet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchStudentHistory.pending, (state) => {
        state.loading = true;
        state.studentHistory = [];
        state.error = null;
      })
      .addCase(fetchStudentHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.studentHistory = action.payload;
      })
      .addCase(fetchStudentHistory.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.payload;
      })
  },
});

export const {
  setHasGivenFeedback,
  setTraineeTestDetails,
  invalidTestUrl,
  testDoneLocal,
  proceedingToTest,
  switchQuestion,
  fetchLoggedInTrainee,
  changeStudentTestTableLoadingStatus,
  changeStudentSearchTutorLoadingStatus,
  changeStudentHistoryTestTableLoadingStatus,
  changeTestSearchText,
  updateTraineeTestQuestions,
  updateTraineeTestQuestionsResult,
  changeTestDetailsModalState,
  updateTraineeTestAnswerSheet,
  fetchPending,
} = testSlice.actions;

export default testSlice.reducer;
